import DOMPurify from 'dompurify';

const ALLOWED_TAGS = [
  'p', 'br', 'strong', 'em', 'b', 'i', 'u', 'ul', 'ol', 'li',
  'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'a', 'span', 'blockquote',
];

const SAFE_PROTOCOLS = new Set(['http:', 'https:', 'mailto:', 'tel:']);

export function isSafeHref(href) {
  const value = String(href || '').trim();
  if (!value) {
    return false;
  }
  if (value.startsWith('//')) {
    return false;
  }
  if (value.startsWith('#') || (value.startsWith('/') && !value.startsWith('//'))) {
    return true;
  }
  try {
    const parsed = new URL(value, 'https://pacilo.local');
    return SAFE_PROTOCOLS.has(parsed.protocol);
  } catch {
    return false;
  }
}

function hardenLinks(node) {
  if (!node || node.tagName !== 'A') {
    return;
  }
  const href = node.getAttribute('href') || '';
  if (!isSafeHref(href)) {
    node.removeAttribute('href');
    node.removeAttribute('target');
    return;
  }
  if (node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
}

if (typeof window !== 'undefined' && !window.__PACILO_DOMPURIFY_HOOK__) {
  window.__PACILO_DOMPURIFY_HOOK__ = true;
  DOMPurify.addHook('afterSanitizeAttributes', hardenLinks);
}

export function sanitizeHtml(html) {
  if (!html) {
    return '';
  }
  return DOMPurify.sanitize(String(html), {
    ALLOWED_TAGS,
    ALLOWED_ATTR: ['href', 'target', 'rel'],
    ALLOW_DATA_ATTR: false,
    ADD_ATTR: ['target', 'rel'],
  });
}

export function SafeHtml({ html, className }) {
  const clean = sanitizeHtml(html);
  if (!clean) {
    return null;
  }
  return <div className={className} dangerouslySetInnerHTML={{ __html: clean }} />;
}
